import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ hideLinkLabel, labelPlaceholder, ...args }) {
    super(args)
    this.attrs.error = ''
    this.children = [
      {
        ...this.getComponentWithVModel('link-input'),
        props: {
          hideLinkLabel,
          labelPlaceholder,
          errors: this.getErrorsForPath(this.modelPath)
        }
      }
    ]
  }
}
